import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'
import { BUY_EVENT_PAYMENT, BUYCOURSE, COURSEVIEW } from '../../Routes/RouteConstent';
import "./membershipDetail.scss";
import parse from 'html-react-parser';
import * as asyncStates from "../../Utils/asyncState";
import { postBuyCourse } from '../StripeForms/paymentsAPI';
import { purchaseEvent } from '../../Utils/gtm';
import { getUserID } from '../../Service/getLocalStorage';
import { usePostHog } from 'posthog-js/react';
import { grinEvent } from '../../Utils/grin';
import { formatSlug } from '../../Utils/Regex';


const MembershipDetail = ({ data, handleNext, loading, setLoading, type }: any) => {
    let tax = 0;
    let Navigate = useNavigate()
    let [calculationTax, setCalculationTax] = useState<number>(data?.amount ? Number(data?.amount) * tax / 100 : 0)
    const [finalAmt, setFinalAmt] = useState(0)
    const [paymentAsyncState, setPaymentAsyncState] =
        useState<asyncStates.AsyncState>(asyncStates.initState);
    const posthog = usePostHog();

    const updateFinalAmt = (amount:number) => setFinalAmt(+amount.toFixed(2));
    const updateCalculationTax = (amount:number) => setCalculationTax(+amount.toFixed(2));

    const finalAmount = () => {
        if (type === "member") {
            data?.price_deduction ? updateFinalAmt((Number(data?.price_deduction) * tax / 100) + Number(data?.price_deduction)) :
                updateFinalAmt((Number(data?.amount) * tax / 100) + Number(data?.amount))
        } else {

            updateFinalAmt((Number(data?.amount) * tax / 100) + Number(data?.amount))
        }
    }
    const taxCalculateFun = () => {
        updateCalculationTax(Number(data?.amount) * tax / 100)
    }
    useEffect(() => {

        finalAmount();
    }, [])




    const buyCourseRequest = async (courseData: any) => {
        let params = {
            ...courseData,
            user_id: getUserID(),
        };

        try {
            setPaymentAsyncState(asyncStates.pendingState);

            const res: any = await postBuyCourse(params);

            if (res.status !== 200) {
                throw { message: res?.data?.message?.join(" ") };
            }

            setPaymentAsyncState(asyncStates.successState);

            purchaseEvent({
                ecommerce: {
                    value: courseData?.amount,
                    transaction_id: `${res?.data?.transaction_id}`,
                    finalAmount: courseData.total_amount,
                },
                items: [
                    {
                        item_name: courseData?.data?.title,
                        item_id: courseData?.course_id,
                        price: courseData?.amount,
                        quantity: "1",
                    },
                ],
            });

            posthog.capture("user-purchases-a-course", {
                courseName: courseData?.data?.title,
                courseId: courseData?.course_id,
                price: courseData?.amount,
                userId: getUserID(),
                finalAmount: courseData.total_amount,
            });

            posthog.capture(`[course-purchased]:${formatSlug(courseData?.data?.title || '')}`, {
                $set: { "last-course-purchased": formatSlug(courseData?.data?.title || '') },
            });

            grinEvent({
                amount: courseData?.total_amount, 
                order_number: `${res?.data?.transaction_id}` 
            });

            Navigate(`${COURSEVIEW}${data?.id}`);

        } catch (err: any) {
            toast.error(err?.message);
            setPaymentAsyncState({
                ...asyncStates.failedState,
                failedMessage: err?.message,
            });
        }
    };

    let handlePayment = () => {
        if (type === "course") {
            const obj = {
                course_id: data?.id,
                tax,
                amount: data?.amount,
                total_amount: finalAmt,
                tax_amount: calculationTax,
                data,
            }

            if (finalAmt === 0) {
                buyCourseRequest(obj);
            } else {
                Navigate(BUYCOURSE, { state: { obj } })
            }
            
        } if (type === "event") {
            const obj = {
                event_id: data?.id,
                tax,
                amount: data?.amount,
                total_amount: finalAmt,
                tax_amount: calculationTax,
                data,
            }

            if (finalAmt === 0) {
                // buyEventRequest(obj);
                Navigate(BUY_EVENT_PAYMENT, { state: { obj } })
            } else {
                Navigate(BUY_EVENT_PAYMENT, { state: { obj } })
            }
            
        }
        else {
            let amt;
            if (data?.price_deduction) {
                amt = data?.price_deduction;
            } else {
                amt = data.amount;
            }
            let obj = {
                amount: amt,
                total_amount: finalAmt,
                tax,
                membership_id: data.id,
                tax_amount: calculationTax
            }

            handleNext(obj)
        }
    }
    // debugger
    return (
        <div>
            <div>
                
                <div className="step-innercontent detail-step4">
                    <div>
                        <h3>{type === "member" ? "Membership" : "Billing"} <span className="strong">Details</span></h3>

                        <div className="inner-monthdiv">
                            <div className={`${data?.class}`}>
                                <div className='payment-details' style={{ border: `1px solid ${data?.color_code}` }}>
                                    <div className="monthbox">
                                        <div className='monthbox-head' style={{ backgroundColor: `${data?.color_code}` }}>
                                            <div className='d-flex justify-content-between justify-content-md-start align-items-start align-items-md-center membership-nm flex-column flex-md-row' >
                                                <h4 className='me-0 me-md-5 pe-0 pe-md-3'>{data?.title}</h4>
                                                <div className="d-flex justify-content-end align-items-center align-items-md-end Plan-price flex-row flex-md-column">
                                                    <div>
                                                        {/* <span className="pCost-old">${data?.base_price} </span> */}
                                                        {/* <span className="pCost">${type === "member" ? data?.price_deduction ? data?.price_deduction : data?.amount : data?.amount} </span><span className="membership-cycle">{type === "member" && "/mo"}</span> */}
                                                        <span className="pCost">${type === "member" ? data?.amount : data?.amount} </span><span className="membership-cycle">{type === "member" && "/mo"}</span>
                                                    </div>
                                                    <div className='ms-2 ms-md-0'>
                                                      {type === "member"?<p className='text-end m-0 p-0'>{data?.sub_title}</p>:""}  
                                                    </div>
                                                </div>
                                                {/* <p className="pricepara">${data?.amount}</p> */}
                                            </div>
                                        </div>

                                        <div className='monthbox-details'>
                                            {parse(String(data?.description))}
                                        </div>

                                        {/* <h4>{data?.title}</h4>
                                        <p className="pricepara">${data?.amount}</p> */}
                                        {/* <p>Monthly access to our members-only classes, Q&As, nursing forum and more! You will be charged $149 each month for access to our full membership program and all member perks.
                                        Enjoy special discounts on lactation and sleep consults. This subscription renews every month.</p> */}
                                        {/* <p>{data?.description}</p> */}
                                    </div>
                                </div>
                                <div className="bill-details" style={{ border: `1px solid ${data?.color_code}` }}>
                                    <h6 style={{ backgroundColor: `${data?.color_code}` }}>Billing Details</h6>
                                    <ul className="first">
                                        <li>
                                            <span className="headingspan">
                                                {{ course: 'Course', event: 'Event' }[type as string] || 'Consult'}{' '}
                                                Total
                                            </span>
                                            <span className="pricespan">${type === "member" ? data?.price_deduction ? data?.price_deduction : data?.amount : data?.amount}</span>
                                        </li>
                                        <li className="inner-spans">
                                            <span>Taxes & Charges</span>
                                            <span>+${calculationTax}</span>
                                        </li>
                                    </ul>
                                    <ul className="pay-list">
                                        <li>
                                            <span className="payspan">Total:</span>
                                            <span className="pay-total">${finalAmt}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button className="btn primary-blue-btn mt-3 mb-5" onClick={handlePayment} style={{ backgroundColor: `${data?.color_code}` }}>{paymentAsyncState.pending ? <CircularProgress /> : "Confirm & Pay"}</button>
                </div>
            </div>
        </div>
    )
}

export default MembershipDetail